import React, { useState } from 'react'
import { Control, FieldValues } from 'react-hook-form'

import s from './styles.module.scss'

import { Icon } from '../../../atoms'
import { Checkbox } from '../../../forms'

interface IHouseSearchFilterCheckboxProps<T extends FieldValues> {
  control: Control<T, any>
  name: string
  options: {
    label: string
    name: string
  }[]
  customOptions?: {
    label: string
    name: string
  }[]
  title?: React.ReactNode
}

export const HouseSearchFilterCheckbox = <T extends FieldValues>({
  control,
  name,
  options,
  customOptions,
  title,
}: IHouseSearchFilterCheckboxProps<T>) => {
  const [displayAll, setDisplayAll] = useState(false)

  if (customOptions) {
    options = customOptions.concat(options)
  }

  return (
    <div className={s.container}>
      {title}
      <ul className={s.options}>
        {(displayAll ? options : options.slice(0, 5)).map((option, index) => {
          return (
            <li key={option.name}>
              <Checkbox
                control={control}
                name={
                  customOptions && index < customOptions.length
                    ? option.name
                    : `${name}.${option.name}`
                }
                rules={{}}
                label={option.label}
                style={{ fontSize: '14px' }}
              />
            </li>
          )
        })}
      </ul>
      {!displayAll && options.length - 5 > 0 && (
        <div className={s.showAllContainer} onClick={() => setDisplayAll(true)}>
          <p>Tout afficher ( {options.length - 5} )</p>
          <Icon name='arrow-down' size={12} color='var(--clr-primary-400)' />
        </div>
      )}
      {displayAll && options.length - 5 > 0 && (
        <div
          className={s.showAllContainer}
          onClick={() => setDisplayAll(false)}
        >
          <p>Afficher moins</p>
          <Icon name='arrow-up' size={12} color='var(--clr-primary-400)' />
        </div>
      )}
    </div>
  )
}
